<div class="bg-white p-4 rounded-2xl border border-gray-100 shadow-xs">
  <h4 class="text-sm font-medium mb-3 flex items-center text-gray-700">
    <img src="../../../../../assets/img/iconos/shield-exclamation.svg" alt="" height="20" width="20" class="mr-2">
    {{ 'Distribución de roles' | translate }}
  </h4>
  @if (!cargando) {
    <div class="w-full h-16 bg-gray-200 rounded-sm overflow-hidden flex">
      @for (rol of usuariosPorRol; track rol) {
        <div
          class="h-full"
          [class]="obtenerColorRol(rol.rol)"
          [style.width.%]="rol.porcentaje">
        </div>
      }
    </div>
    <div class="flex items-center mt-2 text-xs text-gray-500 justify-between">
      @for (rol of usuariosPorRol; track rol) {
        <div class="flex items-center">
          <div class="w-2 h-2 rounded-full mr-1" [ngClass]="obtenerColorRol(rol.rol)"></div>
          <span>{{ obtenerDescripcionRol(rol.rol) | translate }}</span>
        </div>
      }
    </div>
  } @else {
    <div class="w-full h-16 bg-gray-200 rounded-sm overflow-hidden flex mb-2">
      <div class="h-full bg-gray-200" style="width: 30%"></div>
      <div class="h-full bg-gray-200" style="width: 40%"></div>
      <div class="h-full bg-gray-200" style="width: 30%"></div>
    </div>

    <div class="flex items-center justify-between">
      <div class="flex items-center space-x-1">
        <div class="w-2 h-2 rounded-full bg-gray-300"></div>
        <div class="h-3 w-20 bg-gray-200 rounded-sm"></div>
      </div>
      <div class="flex items-center space-x-1">
        <div class="w-2 h-2 rounded-full bg-gray-300"></div>
        <div class="h-3 w-20 bg-gray-200 rounded-sm"></div>
      </div>
      <div class="flex items-center space-x-1">
        <div class="w-2 h-2 rounded-full bg-gray-300"></div>
        <div class="h-3 w-20 bg-gray-200 rounded-sm"></div>
      </div>
    </div>
  }
</div>

